"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const react_redux_1 = require("react-redux");
const routes_1 = require("../constants/routes");
const constants_1 = require("../constants/constants");
const access_auth_thunk_1 = require("../reducers/slices/user/thunks/access_auth_thunk");
const doshx_controls_web_1 = require("doshx_controls_web");
const facetecBypass_1 = require("../helpers/facetecBypass");
const ProtectedRoute = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { user, accessAuth, token } = (0, react_redux_1.useSelector)((state) => state.userState);
    const { loginAuthenticated } = (0, react_redux_1.useSelector)((state) => state.uiState);
    const location = (0, react_router_dom_1.useLocation)();
    const [searchParams] = (0, react_router_dom_1.useSearchParams)();
    const code = searchParams.get("code");
    // If there's a code parameter, wait for accessAuth to be fetched before proceeding
    // This prevents redirecting to FaceTec before we know if user is mobile
    const [waitingForAccessAuth, setWaitingForAccessAuth] = (0, react_1.useState)(!!code);
    const [fetchedCode, setFetchedCode] = (0, react_1.useState)(null);
    // Fetch accessAuth when code parameter is present
    (0, react_1.useEffect)(() => {
        if (code && code !== fetchedCode && token) {
            setFetchedCode(code);
            dispatch((0, access_auth_thunk_1.get_access_details_thunk)({ data: { code }, token }));
        }
    }, [code, token, fetchedCode, dispatch]);
    (0, react_1.useEffect)(() => {
        // If we have a code and accessAuth is now populated, stop waiting
        if (code && accessAuth) {
            setWaitingForAccessAuth(false);
        }
        // If there's no code, don't wait
        if (!code) {
            setWaitingForAccessAuth(false);
        }
    }, [code, accessAuth]);
    // If not logged in, send to login
    if (!(user === null || user === void 0 ? void 0 : user._id)) {
        return react_1.default.createElement(react_router_dom_1.Navigate, { to: routes_1.WELCOME_ROUTE + routes_1.LOG_IN_ROUTE, replace: true });
    }
    // Show loading while waiting for accessAuth to be fetched
    if (waitingForAccessAuth) {
        return (react_1.default.createElement("div", { className: "fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50" },
            react_1.default.createElement("div", { className: "bg-white rounded-lg shadow-2xl p-8 text-center" },
                react_1.default.createElement(doshx_controls_web_1.CircularLoaderControl, { size: "medium" }),
                react_1.default.createElement("p", { className: "mt-4 text-gray-600" }, "Verifying access..."))));
    }
    // MOBILE BYPASS: Mobile users are already authenticated via Sky Lifestyle app
    // Skip FaceTec requirements for mobile users
    if ((accessAuth === null || accessAuth === void 0 ? void 0 : accessAuth.view_type) === constants_1.VIEW_TYPE.MOBILE) {
        return react_1.default.createElement(react_router_dom_1.Outlet, null);
    }
    // BYPASS: Test mode, bypass_skysign_auth permission, or mobile access can skip FaceTec
    if ((0, facetecBypass_1.shouldBypassFaceTec)()) {
        return react_1.default.createElement(react_router_dom_1.Outlet, null);
    }
    // Check if already on biometric route
    const isOnBiometric = location.pathname.startsWith(routes_1.CONSOLE_ROUTE + routes_1.FACETEC_ROUTE);
    const isDocumentLinkRoute = location.pathname.startsWith(`${routes_1.CONSOLE_ROUTE}/document/`) && location.pathname.endsWith("/link");
    // Document signing links intentionally handle verification state inside the page flow so
    // unenrolled/unauthenticated signers can still complete as Not Verified when permitted.
    if (isDocumentLinkRoute) {
        return react_1.default.createElement(react_router_dom_1.Outlet, null);
    }
    // Biometric enforcement: if user not enrolled or not authenticated, redirect to FaceTec gate
    const needsBiometric = !user.facetecDBRef || !loginAuthenticated;
    // Redirect to biometric gate (pass original location for return)
    if (needsBiometric && !isOnBiometric) {
        return react_1.default.createElement(react_router_dom_1.Navigate, { to: routes_1.CONSOLE_ROUTE + routes_1.FACETEC_ROUTE, replace: true, state: { from: location } });
    }
    // Allow access
    return react_1.default.createElement(react_router_dom_1.Outlet, null);
};
exports.default = ProtectedRoute;
